import * as v from "valibot";

export const Order = v.object({
  createdAt: v.date(),
  id: v.union([v.string(), v.number()]),
});
export type Order = v.InferOutput<typeof Order>;

export const OrdersUsingCodeWithinWeek = v.object({
  orders: v.array(Order),
  weekEnd: v.date(),
  weekStart: v.date(),
});
export type OrdersUsingCodeWithinWeek = v.InferOutput<typeof OrdersUsingCodeWithinWeek>;
